import ReportDetailsMap from './ReportDetailsMap.component';

export default ReportDetailsMap;
